<template>
	<svg viewBox="0 0 32 32">
		<path d="M7.932 23.002v5h5l14.746-14.746-5-5zM31.546 9.388c0.241-0.24 0.39-0.573 0.39-0.94s-0.149-0.7-0.39-0.94l-3.12-3.12c-0.24-0.241-0.573-0.39-0.94-0.39s-0.7 0.149-0.94 0.39l-2.44 2.44 5 5z" />
	</svg>
</template>
